import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiTimeEntry,
  ApiTimeEntrySaveInput,
  ApiTimeEntryFilter,
  ApiTimesheetExportFilter,
  ApiTimesheetFilter,
  ApiTimesheetRow,
  ApiTimeTrackingStatus,
} from "@/types/time-tracking.types.ts";

export const apiTimeTracking = {
  clockIn: (comment: string | null) => {
    return api.post<ApiTimeEntry>("/api/v1/time-tracking/clock-in", { comment });
  },
  clockOut: (comment: string | null) => {
    return api.post<ApiTimeEntry>("/api/v1/time-tracking/clock-out", { comment });
  },
  getStatus: () => {
    return api.get<ApiTimeTrackingStatus>("/api/v1/time-tracking/status");
  },
  createEntry: (employeeId: number, data: ApiTimeEntrySaveInput) => {
    return api.post<ApiTimeEntry>(`/api/v1/time-tracking/employees/${employeeId}/entries`, data);
  },
  getEntriesForEmployee: (employeeId: number, filter: ApiTimeEntryFilter) => {
    return api.post<ApiPagedData<ApiTimeEntry>>(
      `/api/v1/time-tracking/employees/${employeeId}/entries/search`,
      filter
    );
  },
  updateEntry: (entryId: number, data: ApiTimeEntrySaveInput) => {
    return api.put<ApiTimeEntry>(`/api/v1/time-tracking/entries/${entryId}`, data);
  },
  deleteEntry: (entryId: number) => {
    return api.delete(`/api/v1/time-tracking/entries/${entryId}`);
  },
  getTimesheets: (filter: ApiTimesheetFilter) => {
    return api.post<ApiPagedData<ApiTimesheetRow>>(
      "/api/v1/time-tracking/timesheets/search",
      filter
    );
  },
  exportTimesheets: (filter: ApiTimesheetExportFilter) => {
    return api.post<BlobPart>("/api/v1/time-tracking/timesheets/export", filter, undefined, {
      responseType: "blob",
    });
  },
};
